import * as React from 'react';
const Meh = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-meh", ...props },
    React.createElement("circle", { cx: "12", cy: "12", r: "10" }),
    React.createElement("line", { x1: "8", y1: "15", x2: "16", y2: "15" }),
    React.createElement("line", { x1: "9", y1: "9", x2: "9.01", y2: "9" }),
    React.createElement("line", { x1: "15", y1: "9", x2: "15.01", y2: "9" })));
export default Meh;
//# sourceMappingURL=Meh.js.map